import { createSlice } from '@reduxjs/toolkit';
import { SORTING } from '../constants';
import initialState from '../initialState';

const slice = createSlice({
  name: SORTING,
  initialState: initialState,
  reducers: {
    sortByLastNames(state) {
      state.volunteers = state.volunteers.sort((a, b) => {
        if (a.lastName < b.lastName) {
          return -1;
        }
        if (a.lastName > b.lastName) {
          return 1;
        }
        return 0;
      });
    },
  },
});

const sortingReducer = {
  [SORTING]: slice.reducer,
};

export const { sortByLastNames } = slice.actions;
export default sortingReducer;
